import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_ICON_VECTOR_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_ICON_VECTOR_TYPE = 'postermywall-icon-vector';
export const ICON_VECTOR_BG_FILL_PROP = 'pmw-icon-bg-fill';
export const ICON_VECTOR_TICK_FILL_PROP = 'pmw-icon-check-fill';
const ICON_VECTOR_DATA_ATTR = 'data-is-pmw-icon-vector';

export const ICON_VECTOR_CHECKMARK_SVG =
  '<svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<rect class="js-icon-vector-background" x="0.500488" width="60" height="60" rx="30" fill="#EBFBF7"/>' +
  '<path class="js-icon-vector-tick" d="M41.4614 21.756C41.8404 22.135 41.8404 22.749 41.4614 23.127L27.2394 37.349C26.8604 37.728 26.2464 37.728 25.8684 37.349L19.4034 30.884C19.0244 30.505 19.0244 29.891 19.4034 29.513C19.7824 29.135 20.3964 29.134 20.7744 29.513L26.5534 35.292L40.0904 21.755C40.4694 21.376 41.0834 21.376 41.4614 21.755V21.756Z" fill="#19AD89"/>' +
  '</svg>';

// Inline 17x16 warning triangle shown next to the form-level email-validation error message.
export const ICON_VECTOR_INLINE_ERROR_SVG =
  '<svg style="position:relative; top:6px; margin-right:5px" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0_1051_15078)">' +
  '<g clip-path="url(#clip1_1051_15078)">' +
  '<path d="M15.1118 13.726H1.88777L8.49977 2.27354L15.1118 13.726ZM9.36577 1.77404C8.98077 1.10754 8.01877 1.10754 7.63377 1.77404L1.02177 13.2265C0.636769 13.893 1.11777 14.7265 1.88777 14.7265H15.1118C15.8818 14.7265 16.3628 13.893 15.9778 13.2265L9.36577 1.77404Z" fill="#9C002F"/>' +
  '<path d="M8.5 5.77405C8.776 5.77405 9 5.99805 9 6.27405V8.94055C9 9.21655 8.776 9.44055 8.5 9.44055C8.224 9.44055 8 9.21655 8 8.94055V6.27405C8 5.99805 8.224 5.77405 8.5 5.77405Z" fill="#9C002F"/>' +
  '<path d="M8 11.6071C8 11.3311 8.224 11.1071 8.5 11.1071H8.507C8.783 11.1071 9.007 11.3311 9.007 11.6071C9.007 11.8831 8.783 12.1071 8.507 12.1071H8.5C8.224 12.1071 8 11.8831 8 11.6071Z" fill="#9C002F"/>' +
  '</g></g>' +
  '<defs>' +
  '<clipPath id="clip0_1051_15078"><rect width="16.2837" height="16" fill="white" transform="translate(0.5)"/></clipPath>' +
  '<clipPath id="clip1_1051_15078"><rect width="16" height="16" fill="white" transform="translate(0.5)"/></clipPath>' +
  '</defs>' +
  '</svg>';

// 61x60 warning triangle shown in the form-level error-box (rendered when submission fails).
export const ICON_VECTOR_ERROR_BOX_SVG =
  '<svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<rect class="js-icon-vector-background" x="0.5" width="60" height="60" rx="30" fill="#FEF3F6"/>' +
  '<path class="js-icon-vector-tick" d="M43.2579 40.5739H17.6109L30.4339 18.3629L43.2569 40.5739H43.2579ZM32.1139 17.3939C31.3679 16.1009 29.5009 16.1009 28.7549 17.3939L15.9319 39.6049C15.1859 40.8979 16.1189 42.5139 17.6119 42.5139H43.2589C44.7519 42.5139 45.6849 40.8979 44.9389 39.6049L32.1159 17.3939H32.1139Z" fill="#B70A3E"/>' +
  '<path class="js-icon-vector-tick" d="M30.4348 25.1519C30.9708 25.1519 31.4048 25.5859 31.4048 26.1219V31.2939C31.4048 31.8299 30.9708 32.2639 30.4348 32.2639C29.8988 32.2639 29.4648 31.8299 29.4648 31.2939V26.1219C29.4648 25.5859 29.8988 25.1519 30.4348 25.1519Z" fill="#B70A3E"/>' +
  '<path class="js-icon-vector-tick" d="M29.4648 36.4651C29.4648 35.9291 29.8988 35.4951 30.4348 35.4951H30.4478C30.9828 35.4951 31.4178 35.9291 31.4178 36.4651C31.4178 37.0011 30.9838 37.4351 30.4478 37.4351H30.4348C29.8988 37.4351 29.4648 37.0011 29.4648 36.4651Z" fill="#B70A3E"/>' +
  '</svg>';

export const POSTERMYWALL_ICON_VECTOR: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'SVG' && el.getAttribute(ICON_VECTOR_DATA_ATTR) !== null ? {type: POSTERMYWALL_ICON_VECTOR_TYPE} : undefined;
  },
  model: {
    defaults: {
      name: window.i18next.t('pmwjs_checkmark'),
      toolbar: [],
      removable: false,
      highlightable: true,
      hoverable: true,
      selectable: true,
      badgable: true,
      copyable: false,
      draggable: false,
      content: ICON_VECTOR_CHECKMARK_SVG,
      attributes: {
        [ICON_VECTOR_DATA_ATTR]: '1',
      },
      style: FORM_ICON_VECTOR_STYLES,
    },
  },
};
